export default "__VITE_ASSET__11ce6580__"